import { FunctionComponent, useState } from 'react';
import './styles/TermsAndConditionsFooter.scss';

import { Checkbox } from './core';
import { IDanceSchool } from '../models';
import { classNames } from '../utils';

interface ITermsAndConditionsFooterProps {
  danceSchool: IDanceSchool;
  disabled?: boolean;
}
export const TermsAndConditionsFooter: FunctionComponent<ITermsAndConditionsFooterProps> = (props: ITermsAndConditionsFooterProps) => {

  const {
    danceSchool,
    disabled
  } = props;

  const [acceptedTermsAndConditions, setAcceptedTermsAndConditions] = useState(false);

  const preventAutoAccept = (e: React.MouseEvent) => {
    e.stopPropagation();
  }

  return (
    <label className={classNames('terms-and-conditions-footer', {
      disabled
    })}>
      <Checkbox
        title='Accept terms and conditions'
        name='termsAndConditions'
        required
        checked={acceptedTermsAndConditions}
        onChange={setAcceptedTermsAndConditions}
        disabled={disabled}
      />

      <div>
        I accept the <a className='ppa-link' href={danceSchool.termsAndConditionsUrl} target='__blank' onClick={preventAutoAccept}>terms and conditions</a>
      </div>
    </label>
  )
} 